import { CLIENT_PORTAL_REFRESH_STORAGE_KEY } from "./clientPortalConstants";

function getSessionStorage() {
  try {
    if (typeof window === "undefined") return null;
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
}

export function readClientPortalRefreshToken() {
  const storage = getSessionStorage();
  if (!storage) return "";

  try {
    return String(storage.getItem(CLIENT_PORTAL_REFRESH_STORAGE_KEY) || "").trim();
  } catch (error) {
    return "";
  }
}

export function writeClientPortalRefreshToken(refreshToken) {
  const storage = getSessionStorage();
  if (!storage) return false;

  const value = String(refreshToken || "").trim();
  if (!value) return false;

  try {
    storage.setItem(CLIENT_PORTAL_REFRESH_STORAGE_KEY, value);
    return true;
  } catch (error) {
    return false;
  }
}

export function clearClientPortalRefreshToken() {
  const storage = getSessionStorage();
  if (!storage) return;

  try {
    storage.removeItem(CLIENT_PORTAL_REFRESH_STORAGE_KEY);
  } catch (error) {
    // Storage can be unavailable in embedded/private contexts.
  }
}
